<template>
    <div class="screenshots-area bg-black-color  pb-75" :class="pt">
        <div class="container">
            <div class="section-title color-white">
                <span class="sub-title text-uppercase  ">{{ role_wise_features?.name || "Our 3rd Party API Integration Services"}}</span>
                <h2>{{ role_wise_features?.title || "Connecting Your Business to a World of Possibilities" }}</h2>
            </div>
            <div class="screenshots-tabs">
                <div class="tabs">
                    <ul class="tabs__header">
                        <li 
                            class="tabs__header-item" 
                            v-for="(tab, index) in tabsWithId" 
                            v-on:click="selectTab(tab.name, tab.id)" 
                            v-bind:class="{ 'active': activeTab == tab.name }"
                            :key="tab.id"
                        >
                        <i :class="iconClasses[index % iconClasses?.length]"></i>
                              {{tab.name}}
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div class="tabs__container">
                        <div 
                            class="tabs__list"
                            ref='tabsList'
                        >
                            <div 
                                class="tabs__list-tab"
                                v-for="tab in tabsWithId"
                                v-bind:class="{ 'active': activeTab == tab.name }"
                                :key="tab.id"
                            >
                                <img :src="`${$backendUrl}${tab?.image?.url || ''}`" :alt="tab?.image?.alternativeText || tab?.name + ' - Feature Screenshot' || 'Feature Screenshot'">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RoleWiseFeatures',
    
     props: {
        role_wise_features: {
            type: Object,
            required: true,
        },
        pt: {
      type: String, // or whatever type you're expecting, maybe Number
      default: 'pt-75',
    },
    }, 
    data() {
    return {
      iconClasses: [
        'ri-eye-line',
        'ri-stack-line',
        'ri-leaf-line',
        'ri-secure-payment-line',
        'ri-cloud-line',
        'ri-pie-chart-2-line',
      ],
   
            activeTab: this.role_wise_features?.feature_names?.[0]?.name || "",
            offsetRight: 0,
        }
    },
    
    computed: {
        tabsWithId() {
            if (!this.role_wise_features?.feature_names) {
                return [];
            }
            return this.role_wise_features.feature_names.map((tab, index) => ({
                ...tab,
                id: index + 1,
            }));
        }
    },

    methods: {
        selectTab (name, id) {
            let tabsList = this.$refs.tabsList
            this.activeTab = name
            if (tabsList && tabsList.parentElement) {
                this.offsetRight = tabsList.parentElement.clientWidth * (id - 1)
                tabsList.style.right = this.offsetRight + 'px'
            }
        }
    },
    mounted () {
        let tabsList = this.$refs.tabsList
        tabsList.style.right = this.offsetRight + 'px'
    }
}
</script>